import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-16fd287c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "app-card centered load-message-wr ion-text-center"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'AppLoadingAlert',
  props: {
    message: {},
    isShowing: {
      type: Boolean
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [_ctx.isShowing ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", null, _toDisplayString(_ctx.message), 1)])) : _createCommentVNode("", true)]),
        _: 1
      });
    };
  }
});